import {IUsefulLinkConfiguration} from "../configurations/config-data-sections/drawer.configuration";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {Check} from "@sparkware/app-utils";


export default class UsefulLinkActions {
  private services: IServiceFactoryExtended;

  constructor(serviceFactory: IServiceFactoryExtended) {
    this.services = serviceFactory;
  }

  public executeAction(link: IUsefulLinkConfiguration) {
    // Handlers are instance methods of `this` named 'on[LinkId]'
    const handler = this._findHandler(link.id);
    if(handler) {
      handler.call(this, link);
    }
  }

  private _findHandler(linkId: string): (link: IUsefulLinkConfiguration) => void {
    if(!linkId || linkId.length < 1) {
      return null;
    }

    const handlerName = 'on' + linkId.charAt(0).toUpperCase() + linkId.slice(1);
    if(Check.isFunction(this[handlerName])) {
      return this[handlerName];
    }

    return null;
  }

  onTransactionHistory() {
    this.services.cashier.openOldCashier({sessionType: 2});
  }

  onReverseWithdrawal() {
    this.services.cashier.openOldCashier({sessionType: 6});
  }

  onUploadDocuments() {
    this.services.cashier.openOldCashier({sessionType: 20});
  }

  onCompPoints() {
    this.services.externalLinks.openMyAccount({tabId: 13});
  }

  onContactUs(link: IUsefulLinkConfiguration) {
    this.services.externalLinks.openContactUs({view: link.target});
  }

  on888club(link: IUsefulLinkConfiguration) {
    this._openLinkAction(link);
  }

  onBeGambleAware(link: IUsefulLinkConfiguration) {
    this._openLinkAction(link);
  }

  onGameCare(link: IUsefulLinkConfiguration) {
    this._openLinkAction(link);
  }

  onSafeZone(link: IUsefulLinkConfiguration) {
    //On 777UK we would like to send users to a link instead of opening the safe zone as there is no safezone in 777UK, so it contains "link" attribute in the config.json
    if(link.link){
      return this._openLinkAction(link);
    }

    this.services.safezone.openFullSafezone();
  }

  onTimeSpentReminder(link: IUsefulLinkConfiguration) {
    this.services.safezone.openFullSafezone();
  }

  onHelp() {
    this.services.externalLinks.openHelpPage();
  }

  private _openLinkAction({local:shouldOpenLocal, link}: IUsefulLinkConfiguration){
    if(shouldOpenLocal) {
      this.services.location.push(link);
    } else {
      this.services.externalLinks.openLink({
        sourceLink: link,
        view: 'window'
      })
    }
  }
}
